import React, { useState, useRef, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { Logo } from "../../assets/svg/index";
import { Link } from "react-router-dom";

import Burger from "./Burger";
import Menu from "./Menu";

const slideInFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  @media (min-width: 61.313em) {
    margin: 0.25rem 2rem;
    padding-top: 0.9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    animation: ${slideInFromTop} 0.6s ease-out;
  }
`;

const LogoWrapper = styled.div`
  width: 150px;
  height: auto;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};

export default function HeaderDesktop() {
  const node = useRef();
  const [open, setOpen] = useState(false);
  useOnClickOutside(node, () => setOpen(false));

  return (
    <Container>
      <Link to="/">
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
      </Link>
      <div ref={node}>
        <Burger open={open} setOpen={setOpen} />
        <Menu open={open} setOpen={setOpen} />
      </div>
    </Container>
  );
}